import type { IPaymentBillingStatus } from '../services/payments/types';

let cachedBillingStatus: IPaymentBillingStatus | null = null;

export const setPaymentBillingStatusCache = (status: IPaymentBillingStatus | null): void => {
  cachedBillingStatus = status;
};

export const getPaymentBillingStatusCache = (): IPaymentBillingStatus | null => cachedBillingStatus;

export const clearPaymentBillingStatusCache = (): void => {
  cachedBillingStatus = null;
};
